<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
        :showBtn="false"
        title="POS Collection Report (Date Wise)"
      />
    </div>

    <div class="my-2 px-2">
      <DateQuerySetter
        btnTitle="Go"
        @onClickGo="onClickGo"
      >

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">User</label>
          <v-select placeholder="User" :options="contactList" label="name"
              :reduce="(name) => name.id" v-model="userId" />
        </div>
      </DateQuerySetter>
    </div>

    <div class="col-12">
      <div class="d-flex justify-content-end px-2">
        <button
            @click="onClickToPrint"
            class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect mx-1"
        >
          Print
        </button>
        <button
            @click="exportTable"
            class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
        >
          Export
        </button>
      </div>
    </div>

    <div class="col-12 px-2 mt-2">
      <ListTable :tableItems="reportList" :totals="totals" :mopHeads="mopHeads"/>
    </div>
  </div>
  <Loader v-if="loading"/>
</template>

<script setup>
import DateQuerySetter from '@/components/atom/DateQuerySetter';
import { ref, inject, onMounted, computed  } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import TitleButton from '@/components/atom/TitleButton';
import ListTable from '@/components/atom/super-shop/pos-collection-report/ListTable.vue';
import handleInventory from "@/services/modules/inventory";
import handleImportTracker from "@/services/modules/procurement/importTracker";
import Loader from "@/components/atom/LoaderComponent.vue";
import handleCompany from "@/services/modules/company";
import pdfPrinter from "@/services/utils/pdf/posCollectionPdf";

const route = useRoute()
const reportList = ref([]);
const userId = ref(null);
const contactList = ref([]);
const loading = ref(false);
const totals = ref({});
const mopHeads = ref([]);
const companyInfo = ref({});

const { fetchPosCollectionReport } = handleInventory();
const { fetchContacts } = handleImportTracker();
const { fetchCompanyInfo } = handleCompany();
const { exportToPDF } = pdfPrinter();

const showSuccess = inject('showSuccess');
const showError = inject('showError');

const companyId = computed(() => {
  return route.params.companyId
})
const startDate = computed(() => {
  return route.query.start
})
const endDate = computed(() => {
  return route.query.end
})

const token = computed(() => localStorage.getItem('token'));

const getQuery = () => {
  let query = '?company_id=' + companyId.value;
  if(startDate.value) query += '&start_date='+startDate.value;
  if(endDate.value) query += '&end_date='+endDate.value;
  if(userId.value) query += '&user_id='+ userId.value;

  return query
}

const onClickGo = async() => {
  loading.value = true;

  const query = getQuery();
  try{
    const res = await fetchPosCollectionReport(query);
    if(! res.status) {
      showError(res.message);
      reportList.value = [];
      return;
    }
    showSuccess(res.message);
    reportList.value = res.data;
    totals.value = res.totals;
    mopHeads.value = res.mop_heads;
  } catch(err){
    console.log(err)
  } finally {
    loading.value = false;
  }
};

async function onClickToPrint() {
  let query = getQuery();
  let tableItems = [];
  let totalValue = {};
  let heads = [];

  await fetchPosCollectionReport(query).then((res) => {
    if(! res.status) return;
    tableItems = res.data;
    totalValue = res.totals;
    heads = res.mop_heads;
  }).then(() => {
    exportToPDF(companyInfo.value, tableItems, totalValue, heads, startDate.value, endDate.value)
  }).catch((err) => {
    console.log(err);
  });
}

const exportTable = () => {
  let query = getQuery();
  let url = `${process.env.VUE_APP_BASE_URL}/export/reports/pos-collection-report${query}&_token=${token.value}&is_export=1`;
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.click();
}

onMounted(async () => {
  loading.value = true

  const companyQuery = `?company_id=${companyId.value}&search_type=all`

  await Promise.all([
    fetchContacts(companyQuery).then(({status, data}) => {
      if (status) contactList.value = data
    }),
    fetchCompanyInfo(companyId.value).then(({status, data}) => {
      if (status) companyInfo.value = data
    }),
  ]).then(() => {
    loading.value = false;
  }).catch((err) => {
    loading.value = false
  });
})
</script>
